import { render } from "./CompanySearchSelect.vue?vue&type=template&id=b2aeece4"
import script from "./CompanySearchSelect.vue?vue&type=script&lang=js"
export * from "./CompanySearchSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__